"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "conca-della-campania": {
    "e5563767": [{
      "hkey": "15398ca8",
      "slug": "conca-della-campania",
      "name": "Conca della Campania",
      "primary": true,
      "skipSearch": false
    }],
    "san-domenico": [{
      "hkey": "15398ca8",
      "slug": "conca-della-campania",
      "name": "Conca della Campania",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;